import { useCoreQuery } from '@tecsinapse-org/portal-menu-kit'
import { useEffect } from 'react'
import { Onboardings } from '@/core/enums/onboardings'
import { useOnboarding } from '@/core/hooks/use-onboarding'
import { homeTour } from '../components/home-tour'

export const useHomeOnboarding = () => {
  const { canOpen, setSteps, setOpen, save } = useOnboarding(Onboardings.HOME)
  const { data } = useCoreQuery()

  useEffect(() => {
    if (canOpen && data?.title) {
      setSteps?.([...homeTour(data.title, save)])
      setOpen()
    }
  }, [canOpen, data, setOpen, setSteps, save])

  return { linkHelpTec: data?.linkHelpTec }
}
